module.exports = __webpack_public_path__ + "static/img/qw_mob_03.2f165f54.png";